import React from 'react'
import LoadingSpinner from './LoadingSpinner'

interface SubmitButtonProps {
  text: string
  disabled?: boolean
  loading?: boolean
  onSubmit: () => void
  onDisabled?: () => void
  marginBottom?: number
  addClassName?: string
  type?: 'default' | 'outline' // 버튼 타입
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  text,
  disabled = false,
  loading = false,
  onSubmit,
  onDisabled,
  marginBottom = 0,
  addClassName = '',
  type = 'default',
}) => {
  const getButtonStyles = () => {
    if (disabled || loading) {
      if (type === 'outline') {
        return 'cursor-not-allowed bg-transparent border border-brandPrimary-20% text-brown-80%-main'
      }
      return 'cursor-not-allowed bg-E8E1D9 text-[#918063]'
    }

    if (type === 'outline') {
      return 'cursor-pointer bg-transparent border border-brandPrimary text-brown-80%-main hover:opacity-70 active:opacity-70'
    }

    return 'cursor-pointer bg-brown-80%-main text-backgroundPrimary'
  }

  return (
    <button
      type="button"
      onClick={() => {
        if (disabled || loading) {
          onDisabled?.()
        } else {
          onSubmit()
        }
      }}
      className={`
        w-full
        flex items-center justify-center
        py-16px
        rounded-full
        font-pretendard font-bold text-16px leading-24px text-center
        gap-8px
        ${getButtonStyles()}
        ${marginBottom ? `mb-${marginBottom}px` : ''}
        ${addClassName}
      `}
    >
      {loading && <LoadingSpinner size={20} onDark={!disabled && type !== 'outline'} />}
      {text}
    </button>
  )
}

export default SubmitButton
